import { IImageZone } from '../../../types/image-zone'
import { useGet } from '../../query/useGet'
import { useQuery } from '@tanstack/react-query'
import axiosClient from '../../axios'

export function useGetAllImageZones(
  diagnosticId: string,
  diagnosticImageId: string,
  onlyAddedBySelf: boolean = false
) {
  const condition = onlyAddedBySelf ? `?isAddedBySelf=${onlyAddedBySelf}` : ''
  const imageZones = useGet<IImageZone[]>(
    `diagnostics/${diagnosticId}/diagnostic-images/${diagnosticImageId}/image-zones${condition}`
  )
  const result = imageZones.data

  return { result, ...imageZones }
}

export function useGetImageZones(diagnosticImageId: string) {
  return useQuery({
    queryKey: ['image-zones', diagnosticImageId],
    queryFn: async () => {
      if (!diagnosticImageId) return []
      const { data } = await axiosClient.get<IImageZone[]>(
        `/diagnostics/diagnostic-images/${diagnosticImageId}/image-zones`
      )
      return data
    },
    enabled: !!diagnosticImageId,
  })
}
